import React from 'react';
import {StatisticWidgetDef} from '../types';
import './WidgetSkeleton.css';

const BAR_HEIGHTS = [58, 42, 74, 50, 88, 64, 70];

/**
 * Loading placeholder shaped like the widget that is coming (bars, a line, a
 * donut, a number or table rows), with a soft shimmer; fills its container.
 */
export const WidgetSkeleton: React.FC<{type?: StatisticWidgetDef['type'] | null}> = ({type}) => {
    let shape: React.ReactNode;
    switch (type) {
        case 'kpi':
            shape = (
                <div className="widget-skeleton-kpi">
                    <span className="widget-skeleton-block" style={{width: '46%', height: 34}}/>
                    <span className="widget-skeleton-block" style={{width: '28%', height: 10}}/>
                </div>
            );
            break;
        case 'pie':
            shape = <div className="widget-skeleton-donut"><span className="widget-skeleton-block"/></div>;
            break;
        case 'line':
            shape = (
                <svg className="widget-skeleton-line" viewBox="0 0 100 40" preserveAspectRatio="none" aria-hidden="true">
                    <polyline points="0,30 14,24 28,27 42,16 56,20 70,10 84,14 100,6" fill="none"/>
                </svg>
            );
            break;
        case 'table':
            shape = (
                <div className="widget-skeleton-rows">
                    {[88, 72, 80, 64, 76].map((width, index) => (
                        <span key={index} className="widget-skeleton-block" style={{width: `${width}%`}}/>
                    ))}
                </div>
            );
            break;
        default:
            shape = (
                <div className="widget-skeleton-bars">
                    {BAR_HEIGHTS.map((height, index) => (
                        <span key={index} className="widget-skeleton-block" style={{height: `${height}%`}}/>
                    ))}
                </div>
            );
    }

    return (
        <div className="widget-skeleton" role="status" aria-label="Načítavam widget">
            {shape}
        </div>
    );
};

const TABLE_WIDTHS = [[70, 45, 55, 40], [55, 60, 40, 50], [80, 35, 60, 45], [60, 50, 45, 55], [75, 40, 50, 35], [50, 55, 60, 40]];

/**
 * First load of a statistic's table: the card-table markup with shimmering
 * cells, so the card already has the height of a short result.
 */
export const StatisticTableSkeleton: React.FC = () => (
    <div className="statistic-table-skeleton" role="status" aria-label="Načítavam štatistiku">
        <table className="table card-table table-vcenter datatable mb-0">
            <thead>
                <tr>
                    {[48, 36, 40, 32].map((width, index) => (
                        <th key={index}><span className="widget-skeleton-block" style={{width: `${width}%`, height: 10}}/></th>
                    ))}
                </tr>
            </thead>
            <tbody>
                {TABLE_WIDTHS.map((row, rowIndex) => (
                    <tr key={rowIndex}>
                        {row.map((width, index) => (
                            <td key={index}><span className="widget-skeleton-block" style={{width: `${width}%`, height: 12}}/></td>
                        ))}
                    </tr>
                ))}
            </tbody>
        </table>
    </div>
);
